<template>
    <div class="form-field-live-chat">
        <label :for="id" :class="labelClasses">{{ label }}</label>
        <div class="mt-2.5">
            <input
                :type="type"
                :name="id"
                :id="id"
                :placeholder="placeholder"
                :value="value"
                @input="(event) => { $emit('update', {field, value: event.target.value, event}) }"
                :class="inputClasses"
                @focus="(event) => { $emit('focused', {field, value: event.target.value, event}) }"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFieldLiveChat',
    props: {
        id: {
            required: false,
            type: String,
            default: null,
        },
        label: {
            required: false,
            type: String,
            default: null,
        },
        field: {
            required: false,
            type: String,
            default: null,
        },
        value: {
            required: false,
            type: String,
            default: null,
        },
        placeholder: {
            required: false,
            type: String,
            default: null,
        },
        type: {
            required: false,
            type: String,
            default: 'text',
        },
    },
    computed: {
        labelClasses () {
            const cls = {};
            cls['text-md block font-semibold leading-6 text-zinc-900'] = true;
            return cls;
        },
        inputClasses () {
            const cls = {};
            cls['block w-full rounded-md border-0 px-4 py-2.5 outline-0 shadow-sm'] = true;
            cls['sm:text-sm sm:leading-6'] = true;
            cls['bg-zinc-200 text-black placeholder:text-zinc-600'] = true;
            return cls;
        },
    },
};
</script>
